import React from 'react';
import './LoadingItemSpinner.css';
import VoxelText from '../../../../../components/voxel/Text/VoxelText';
import VoxelLoadingSpinner from '../../../../../components/voxel/Animation/VoxelLoadingSpinner';

export interface LoadingItemProps {
  status?: LoadingStatus;
  label: string;
}

export type LoadingStatus = 'queued' | 'loading';

export const LoadingItem: React.FC<LoadingItemProps> = ({ label, status }) => {
  const sizeClass = 'h-4 w-4';
  const queuedClasses = `
    ${sizeClass}
    border-[2px]
    border-voxel-blue-100
    block absolute
    rounded-full
`;

  return (
    <div className="flex flex-row items-center gap-4 h-6">
      {(status === 'queued' || !status) && (
        <div className={sizeClass}>
          <div className={queuedClasses} />
        </div>
      )}
      {status === 'loading' && <VoxelLoadingSpinner color="gray" sizeClass={sizeClass} />}
      <VoxelText paddingBot={false} paddingTop={false}>
        {label}
      </VoxelText>
    </div>
  );
};

export default LoadingItem;
